<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc sub"><a href="#/front03">Epigraphs</a></p>
<p class="toc"><a href="#/c01">Friday Afternoon</a></p>
<p class="toc"><a href="#/c02">Friday, Early Evening</a></p>
<p class="toc"><a href="#/c03">Friday Evening</a></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">Friday Night</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Saturday Morning and Afternoon</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Saturday Afternoon and Evening</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Saturday Evening</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">Sunday Morning</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Sunday Afternoon and Evening</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Monday Morning and Afternoon</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">Monday Night, Tuesday Morning</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">Tuesday Morning and Afternoon</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Tuesday Evening</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">Late Tuesday Evening</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Late Tuesday Night, Wednesday Morning</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">Wednesday</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">Thursday</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">Friday Morning</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">Friday Afternoon</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">Dawn</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Sample Chapter from A WIZARD ALONE</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Buy the Book</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Read More from the Young Wizards Series</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">About the Author</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0ac2acbf